/**
 * fix-trustoo-tap.js
 * 
 * PROBLEMA: theme.js (FoxTheme) registra un handler touchend su document in bubble phase
 * che chiama e.preventDefault() per tutti i target non-checkbox/radio, poi dispatcha
 * un click sintetico SOLO se il target e' dentro a/button/label/select/summary/[role=button].
 * 
 * .slide-option di Trustoo e' un <div> senza role="button", quindi:
 * 1. preventDefault() blocca il click nativo del browser
 * 2. il click sintetico non viene dispatchato (target non e' interattivo per FoxTheme)
 * 3. Trustoo (che ascolta solo su click) non riceve nulla
 * 
 * SOLUZIONE: listener in capture phase su document, eseguito PRIMA dell'handler di FoxTheme.
 * Se il target e' dentro .trustoo-widget, dispatcha il click sintetico e chiama
 * stopPropagation() per impedire che l'evento raggiunga l'handler di FoxTheme.
 * 
 * Questo approccio:
 * - Non modifica theme.js (sopravvive agli aggiornamenti di FoxTheme)
 * - Non tocca le configurazioni di Trustoo
 * - Non altera il comportamento del tema su tutti gli altri elementi
 * - E' reversibile: basta rimuovere questo file e il tag <script> dal liquid
 * 
 * Data: 2026-08-28
 * Autore: web-dev (Brand OS)
 * Riferimento: 04 - Sito & E-commerce/operazioni-shopify/2026-08-27_bug-confermato_modal-recensioni-non-tappabile-mobile.md
 */

(function () {
  'use strict';

  // Selettori Trustoo che contengono elementi interattivi non-button
  var TRUSTOO_SELECTOR = '.trustoo-widget';

  document.addEventListener(
    'touchend',
    function (e) {
      // Eseguito in capture phase, prima dell'handler di FoxTheme

      // Verifica se il target e' dentro un widget Trustoo
      if (!e.target.closest(TRUSTOO_SELECTOR)) return;

      // Il target e' dentro Trustoo: dispatcha il click sintetico
      var touch = e.changedTouches[0];
      if (!touch) return;

      // Impedisce che l'evento raggiunga l'handler di FoxTheme in bubble phase
      e.stopPropagation();

      // Dispatcha il click sul target (bubbles:true lo fa risalire a .slide-option)
      e.target.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: touch.clientX,
          clientY: touch.clientY,
        })
      );
    },
    true // capture phase: eseguito prima degli handler in bubble phase
  );
})();
